import React from 'react';

function Footer () {
	return (
		<React.Fragment>
				<div className="footer-background">
						<footer>
							2020 LAFFY | ALL RIGHTS RESERVED
						</footer>
				</div>
		</React.Fragment>
	)
}

export default Footer;


